export default __webpack_public_path__ + "static/media/blockchain-background.fcc619f5.png";